import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CourseCategoryDto} from './dtos/coursecategory.dto';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {CourseCategoryQueryDto} from './dtos/coursecategoryquery.dto';
import {GroupSeriesQueryDto} from './dtos/groupseriesquery.dto';
import {GroupSeriesInfoDto} from './dtos/groupseriesinfo.dto';
import {GroupSeriesParameterDto} from './dtos/groupseriesparameter.dto';
import {BookGroupsDto} from './dtos/bookgroups.dto';
import {GroupBookingResponseDto} from './dtos/group-booking-response.dto';
import {GroupWeeklyRequestDto} from './dtos/groupweeklyrequest.dto';
import {GroupScheduleDto} from './dtos/groupschedule.dto';

@Injectable({
  providedIn: 'root'
})
export class CourseService {

  http: HttpClient = inject(HttpClient);

  queryCategories(courseCategoryQueryDto: CourseCategoryQueryDto): Observable<CourseCategoryDto[]> {
    return this.http.post<CourseCategoryDto[]>(`${environment.cenplexBookingApiBaseUrl}/courses/query`, courseCategoryQueryDto);
  }

  loadWeeklyCourses(queryDto: GroupWeeklyRequestDto): Observable<GroupScheduleDto[]> {
    return this.http.post<GroupScheduleDto[]>(`${environment.cenplexBookingApiBaseUrl}/courseweekly/query`, queryDto);
  }

  loadCourses(queryDto: GroupSeriesQueryDto): Observable<GroupSeriesInfoDto[]> {
    return this.http.post<GroupSeriesInfoDto[]>(`${environment.cenplexBookingApiBaseUrl}/courselist/query`, queryDto);
  }

  loadCourseInfo(queryDto: GroupSeriesParameterDto): Observable<GroupSeriesInfoDto> {
    return this.http.post<GroupSeriesInfoDto>(`${environment.cenplexBookingApiBaseUrl}/courseinfo/${queryDto.groupId}`, queryDto);
  }

  loadCourse(queryDto: GroupSeriesParameterDto): Observable<GroupSeriesInfoDto> {
    return this.http.post<GroupSeriesInfoDto>(`${environment.cenplexBookingApiBaseUrl}/courses/${queryDto.groupId}/query`, queryDto);
  }

  bookCourses(request: BookGroupsDto): Observable<GroupBookingResponseDto[]> {
    return this.http.post<GroupBookingResponseDto[]>(`${environment.cenplexBookingApiBaseUrl}/courses/${request.courseId}/book`, request);
  }
}
